// extracted by mini-css-extract-plugin
export default {"container":"Navbar_container__mSzg2","logo":"Navbar_logo__QSF-E","feedback":"Navbar_feedback__L1G+C"};